export interface WebsiteEditingAvailability {
  panelActive: boolean
  viewingPublishedVersion: boolean
  viewingHistoricalRevision: boolean
  htmlContent: string | null | undefined
}

/**
 * Structured edit context is valid only after the builder has emitted a real
 * canonical preview. Discovery and plan turns can already have internal
 * revisions, but the UI does not know their head revision yet; treating the
 * empty "Building site" panel as revision 0 creates a guaranteed stale edit.
 */
export function hasEditableWebsiteSnapshot({
  panelActive,
  viewingPublishedVersion,
  viewingHistoricalRevision,
  htmlContent,
}: WebsiteEditingAvailability): boolean {
  return panelActive
    && !viewingPublishedVersion
    && !viewingHistoricalRevision
    && typeof htmlContent === 'string'
    && htmlContent.trim().length > 0
}
